<template>
  <div class="flex flex-col items-center py-5 text-gray-700" style="font-family: Noto Sans JP;">
    <img
      v-if="giftOpen"
      class="mb-3"
      src="@/assets/default/images/giftbox.svg"
    />
    <img
      v-else
      class="mb-3"
      src="@/assets/default/images/giftbox-closed.svg"
    />
    <div class="flex flex-row justify-center items-end relative">
      <img
        class="relative bottom-3"
        :class="[
          !giftOpen && 'invisible'
        ]"
        src="@/assets/default/images/star-left.svg"
      />
      <div class="flex flex-col items-center font-black">
        <div class="font-bold">
          LINE Pay残高
        </div>
        <div class="relative z-0">
          <div class="z-0 absolute -inset-x-0.5 bottom-0 top-2/3 rounded-sm bg-green-400 opacity-30" />
          <div class="relative z-10">
            <span class="text-2xl">{{ amount.toLocaleString() }}円</span><span class="text-lg">相当</span>
          </div>
        </div>
        <div v-if="giftOpen" class="text-line">
          ゲット!
        </div>
        <div v-else class="text-line">
          プレゼント
        </div>
      </div>
      <img
        class="relative bottom-3"
        :class="[
          !giftOpen && 'invisible'
        ]"
        src="@/assets/default/images/star-right.svg"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'LinePayGiftContent',
  props: {
    giftOpen: {
      type: Boolean,
      default: true,
    },

    amount: {
      type: Number,
      default: 0,
    },
  },
});
</script>
